/* C Clips (sections/c-clips.liquid, 14 October 2026). Loaded (deferred) only by that section.
   A tap on a clip card makes its <video> (nothing is downloaded before), picks the 480p file under 750 px and 720p above, and
   plays it inline with sound (muted only if the browser refuses sound). One clip plays at a time; it pauses when its card is
   mostly off screen, when the tab is hidden, or on a second tap. The 2 paddles (laptops) move the row by one card and hide
   when every card already fits. Works for every C Clips section on the page and for sections the theme editor adds. */
(function () {
  'use strict';
  if (window.__clLoaded) return;
  window.__clLoaded = true;
  var D = document, W = window, live = null;

  function label(c, playing) {
    var t = c.querySelector('.cl__tap');
    if (t) t.setAttribute('aria-label', t.getAttribute(playing ? 'data-pause' : 'data-play'));
  }
  function stop() {
    if (!live) return;
    live.v.pause();
    live.c.classList.remove('is-play');
    label(live.c, false);
    live = null;
  }
  function play(c) {
    if (live && live.c === c) { stop(); return; }
    stop();
    var v = c.querySelector('video');
    if (!v) {
      var sm = c.getAttribute('data-src-sm'), lg = c.getAttribute('data-src');
      if (!lg) return;
      v = D.createElement('video');
      v.className = 'cl__v';
      v.setAttribute('playsinline', '');
      v.playsInline = true;
      v.preload = 'auto';
      v.src = (W.innerWidth < 750 && sm) ? sm : lg;
      c.insertBefore(v, c.querySelector('.cl__tap'));
      var bar = c.querySelector('.cl__bar i');
      v.addEventListener('timeupdate', function () { if (bar && v.duration) bar.style.transform = 'scaleX(' + Math.min(1, v.currentTime / v.duration) + ')'; });
      v.addEventListener('ended', function () { if (live && live.v === v) stop(); v.currentTime = 0; if (bar) bar.style.transform = ''; });
    }
    v.muted = false;
    var p = v.play();
    if (p && p.catch) p.catch(function () { v.muted = true; var q = v.play(); if (q && q.catch) q.catch(function () {}); });
    c.classList.add('is-play');
    label(c, true);
    live = { v: v, c: c };
  }

  var io = W.IntersectionObserver ? new IntersectionObserver(function (E) {
    E.forEach(function (e) { if (live && e.target === live.c && e.intersectionRatio < 0.35) stop(); });
  }, { threshold: [0, 0.35] }) : null;

  function init(s) {
    if (!s || s.__cl) return;
    s.__cl = true;
    var row = s.querySelector('[data-cl-row]'), pads = s.querySelector('[data-cl-pads]');
    s.addEventListener('click', function (e) { var t = e.target.closest('.cl__tap'); if (t) play(t.closest('.cl__c')); });
    if (io) [].forEach.call(s.querySelectorAll('.cl__c[data-src]'), function (c) { io.observe(c); });
    if (!row || !pads) return;
    var bs = pads.querySelectorAll('[data-cl-pad]');
    function state() {
      var over = row.scrollWidth > row.clientWidth + 4;
      pads.hidden = !over;
      if (!over) return;
      bs[0].disabled = row.scrollLeft < 4;
      bs[1].disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 4;
    }
    [].forEach.call(bs, function (b) {
      b.addEventListener('click', function () {
        var c = row.querySelector('.cl__c'), g = parseFloat(getComputedStyle(row).columnGap) || 20;
        row.scrollBy({ left: +b.getAttribute('data-cl-pad') * (c ? c.offsetWidth + g : row.clientWidth), behavior: 'smooth' });
      });
    });
    row.addEventListener('scroll', state, { passive: true });
    W.addEventListener('resize', state);
    state();
  }
  function all() { [].forEach.call(D.querySelectorAll('[data-cl]'), init); }

  D.addEventListener('visibilitychange', function () { if (D.hidden) stop(); });
  D.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-cl]')); });
  D.addEventListener('shopify:section:unload', function (e) { if (live && e.target.contains(live.c)) stop(); });
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', all); else all();
})();
